export const PILOT_THIRD_PARTY_SENSORS_TABLE_FRENCH_LOCALE = {
  globalSearchPlaceholder: "Rechercher une valeur...",
  empty: "Aucun capteurs tiers trouvé...",
  headers: {
    serialNumber: "Numéro de série",
    hwId: "Hardware Id",
    csId: "Cs Id",
    neuronId: "Neuron Id",
    siteId: "Site Id",
  },
  filters: {
    placeholders: {
      serialNumber: "Rechercher par numéro de série...",
      hwId: "Rechercher par hardware Id...",
      csId: "Rechercher par cs Id...",
      neuronId: "Rechercher par neuron Id...",
      siteId: "Rechercher par site Id...",
    },
  },
};
